package io.horion.cv.components.cards

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import io.horion.cv.components.widgets.FormCard
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.EditButtonBoxStyle
import io.horion.cv.styles.EditButtonIconStyle
import io.horion.cv.styles.GenericSummaryRowStyle
import io.horion.cv.styles.SummaryDefaultTextStyle
import io.horion.cv.styles.SummarySubtitleStyle
import io.horion.cv.styles.SummaryTitleStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

data class SummaryData(
    val title: String,
    val subtitle: String
)

@Composable
fun <T> GenericFormCard(
    item: T,
    isEditing: Boolean,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onComplete: () -> Unit,
    getSummary: (T) -> SummaryData?,
    getDefaultText: () -> String,
    formContent: @Composable (T, () -> Unit, () -> Unit) -> Unit,
    modifier: Modifier = Modifier
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val titleColor    = if (isDark) Colors.White     else Colors.Primary
    val subtitleColor = if (isDark) Colors.LightGray else Colors.gray
    val defaultColor  = if (isDark) Colors.LightGray else Colors.Primary
    val btnBorder     = if (isDark) Colors.Placeholder else Colors.LightGray
    val iconFilter    = if (isDark) "none"           else "invert(0.4)"

    FormCard(modifier = modifier) {
        if (isEditing) {
            formContent(item, onDelete, onComplete)
        } else {
            Row(
                modifier = GenericSummaryRowStyle.toModifier(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                val summary = getSummary(item)

                if (summary != null) {
                    Column(
                        modifier = Modifier
                            .weight(1f)
                            .minWidth(0.px),
                        verticalArrangement = Arrangement.spacedBy(10.px)
                    ) {
                        SpanText(
                            text = summary.title,
                            modifier = SummaryTitleStyle.toModifier()
                                .fontWeight(FontWeight.Bold)
                                .color(titleColor)
                                .fontFamily(INTER)
                        )
                        SpanText(
                            text = summary.subtitle,
                            modifier = SummarySubtitleStyle.toModifier()
                                .fontWeight(FontWeight.Normal)
                                .color(subtitleColor)
                                .fontFamily(INTER)
                        )
                    }
                } else {
                    SpanText(
                        text = getDefaultText(),
                        modifier = SummaryDefaultTextStyle.toModifier()
                            .color(defaultColor)
                            .fontFamily(INTER)
                    )
                }

                Box(
                    modifier = EditButtonBoxStyle
                        .toModifier()
                        .styleModifier {
                            property("flex-shrink", "0")
                        }
                        .border(1.px, LineStyle.Solid, btnBorder)
                        .borderRadius(7.px)
                        .cursor(Cursor.Pointer)
                        .onClick { onEdit() },
                    contentAlignment = Alignment.Center
                ) {


                    FaPen(
                        modifier = EditButtonIconStyle.toModifier()
                            .color(Color.rgb(0xb5, 0xb5, 0xb5))
                            .styleModifier {
                                property("filter", iconFilter)
                            }
                    )
                }
            }
        }
    }
}